import { getCommonIconProps, IconProps } from ".";

export const FacebookIcon = (props: IconProps) => {
  return (
    <svg {...getCommonIconProps(props)}>
      <path
        d="m12.58 19.11h-2.82c-.19 0-.35-.16-.35-.35v-6.67h-1.1c-.19 0-.35-.16-.35-.35v-2.31c0-.19.16-.35.35-.35h1.1v-1.08c0-2.26 1.2-3.4 3.58-3.4.85 0 1.49.13 2.22.28.18.04.3.21.28.4l-.35 2.21c-.01.09-.07.18-.15.23s-.17.08-.27.06c-.37-.07-.88-.13-1.18-.13-.61 0-.61.11-.61.67v.76h1.9c.1 0 .19.04.26.11s.1.17.09.27l-.2 2.31c-.02.18-.17.32-.35.32h-1.7v6.67c0 .19-.16.35-.35.35zm-2.47-.7h2.12v-6.67c0-.19.16-.35.35-.35h1.73l.14-1.61h-1.87c-.19 0-.35-.16-.35-.35v-1.12c0-.66.1-1.37 1.31-1.37.25 0 .62.03.96.08l.24-1.53c-.58-.12-1.09-.2-1.75-.2-1.99.01-2.88.84-2.88 2.71v1.43c0 .19-.16.35-.35.35h-1.1v1.61h1.1c.19 0 .35.16.35.35z"
        fill="currentColor"
      />
    </svg>
  );
};
